import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'
const { makeStyles } = require('@material-ui/core')

export const useDocumentCardStyles = makeStyles(() => ({
  pagination: {
    '& .MuiPaginationItem-root': {
      margin: 0
    },
    '& .MuiPagination-ul li:first-child button': {
      borderRadius: 8
    },
    '& .MuiPagination-ul li:last-child button': {
      borderRadius: 8
    },
    '& .MuiPagination-ul li:not(:last-child):not(:first-child) button': {
      borderRadius: 8
    }
  },
  card: {
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: 14,
    fontWeight: 600
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    color: PRIMARY_COLORS[700],
    marginBottom: 8
  },
  subTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: GRAY_COLORS[900],
    marginBottom: 8
  },
  description: {
    fontSize: 14,
    fontWeight: 400,
    color: GRAY_COLORS[500]
  },
  answer: {
    fontSize: 14,
    fontWeight: 500,
    color: GRAY_COLORS[900]
  }
}))
